import { NavLink, useLocation } from "react-router-dom"
import {
  FileText,
  Clipboard,
  ClipboardList,
  IndianRupee,
  Scan,
  Settings,
  HelpCircle,
  Bell,
  Activity,
} from "lucide-react"

export default function Sidebar({ isOpen, closeSidebar }) {
  const location = useLocation()

  return (
    <aside className={`sidebar-client ${isOpen ? "open" : ""}`}>
      {/* Mobile Profile Section */}
      <div className="mobile-profile-section">
        <div className="mobile-only-sidebar-item profile-item">
          <div className="user-profile">JD</div>
          <span>John Doe</span>
        </div>
      </div>

      <nav className="sidebar-nav">
        <ul>
          {/* <li>
            <NavLink
              to="/reports/dashboard"
              className={({ isActive }) => (isActive ? "active" : "")}
              onClick={closeSidebar}
            >
              <Activity />
              <span>Dashboard</span>
            </NavLink>
          </li> */}
          <li>
            <NavLink
              to="/reports/health-reports"
              className={({ isActive }) => (isActive ? "active" : "")}
              onClick={closeSidebar}
            >
              <FileText />
              <span>Health Reports</span>
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/reports/prescriptions"
              className={({ isActive }) => (isActive ? "active" : "")}
              onClick={closeSidebar}
            >
              <Clipboard />
              <span>Prescriptions</span>
            </NavLink>
          </li>
          {/* <li>
            <NavLink
              to="/reports/prescription-details"
              className={({ isActive }) => (isActive ? "active" : "")}
              onClick={closeSidebar}
            >
              <ClipboardList />
              <span>Prescription Details</span>
            </NavLink>
          </li> */}
          <li>
            <NavLink
              to="/reports/bills-receipts"
              className={({ isActive }) => (isActive ? "active" : "")}
              onClick={closeSidebar}
            >
              <IndianRupee />
              <span>Bills & Receipts</span>
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/reports/scanner"
              className={({ isActive }) => (isActive ? "active" : "")}
              onClick={closeSidebar}
            >
              <Scan />
              <span>Scanner</span>
            </NavLink>
          </li>
        </ul>
      </nav>

      {/* <div className="sidebar-footer">
        <NavLink to="/settings" className={({ isActive }) => (isActive ? "active" : "")}>
          <Settings />
          <span>Settings</span>
        </NavLink>
        <NavLink to="/help" className={({ isActive }) => (isActive ? "active" : "")}>
          <HelpCircle />
          <span>Help</span>
        </NavLink>
        <NavLink to="/notifications" className="mobile-only-sidebar-item">
          <Bell />
          <span>Notifications</span>
        </NavLink>
      </div> */}
    </aside>
  )
}
